import { useQuery } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { VippsStatus } from '@/generated-types';
import { REST_BASE_URL } from '@/react-query/common';

const getDebitVipps = async () => get<VippsStatus>(`${REST_BASE_URL}/debit-card-vipps?deviceType=MOBILE_PHONE`);

export const useDebitVippsQuery = () => {
    return useQuery<VippsStatus>({
        queryKey: ['v3', 'debit-card-vipps'],
        queryFn: getDebitVipps,
    });
};
